import imageUrls from './imagePaths';

const preloadImages = () => {
  Object.values(imageUrls).forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

export default preloadImages;